import React from "react"
import { useLocation, Route, Routes, Navigate, Link } from "react-router-dom"
// reactstrap components
import { Container, Row, Col, Navbar, NavbarBrand } from "reactstrap"

import routes from "./routes"

const Auth = props => {
  const mainContent = React.useRef(null)
  const location = useLocation()

  React.useEffect(() => {
    document.body.classList.add("bg-default")
    return () => {
      document.body.classList.remove("bg-default")
    }
  }, [])
  React.useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    mainContent.current.scrollTop = 0
  }, [location])

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        )
      } else {
        return null
      }
    })
  }

  return (
    <>
      <div
        className="main-content"
        ref={mainContent}
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Modern Navbar */}
        <Navbar
          className="navbar-top navbar-horizontal"
          expand="md"
          style={{
            background: "transparent",
            padding: "16px 0",
            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
          }}
        >
          <Container className="px-4">
            <NavbarBrand to="/" tag={Link} style={{ textDecoration: "none" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <div
                  style={{
                    width: "45px",
                    height: "45px",
                    background:
                      "linear-gradient(135deg, #f5365c 0%, #d63031 100%)",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 15px rgba(245, 54, 92, 0.4)",
                  }}
                >
                  <i
                    className="ni ni-delivery-fast"
                    style={{ fontSize: "22px", color: "#fff" }}
                  />
                </div>
                <div>
                  <h3
                    style={{
                      color: "#fff",
                      fontSize: "22px",
                      fontWeight: "700",
                      marginBottom: "0",
                      letterSpacing: "0.5px",
                    }}
                  >
                    SPEEDWORKS
                  </h3>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.6)",
                      fontSize: "11px",
                      marginBottom: "0",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                    }}
                  >
                    Admin Portal
                  </p>
                </div>
              </div>
            </NavbarBrand>
          </Container>
        </Navbar>

        {/* Page content */}
        <Container
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            paddingTop: "40px",
            paddingBottom: "40px",
          }}
        >
          <Row className="justify-content-center" style={{ width: "100%" }}>
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Auth
